/**
 * @link https://tk.wikipedia.org/wiki/T%C3%BCrkmenistandaky_etraplar_we_%C5%9F%C3%A4herler
 * @date 15-05-2013
 */
const cities = [
  {
    name: 'Abadan',
    province: 'Ahal'
  },
  {
    name: 'Aşgabat',
    province: 'Aşgabat'
  },
  {
    name: 'Atamyrat',
    province: 'Lebap'
  },
  {
    name: 'Änew',
    province: 'Ahal'
  },
  {
    name: 'Baharly',
    province: 'Ahal'
  },
  {
    name: 'Balkanabat',
    province: 'Balkan'
  },
  {
    name: 'Baýramaly',
    province: 'Mary'
  },
  {
    name: 'Bereket',
    province: 'Balkan'
  },
  {
    name: 'Daşoguz',
    province: 'Daşoguz'
  },
  {
    name: 'Garabogaz',
    province: 'Balkan'
  },
  {
    name: 'Gazojak',
    province: 'Lebap'
  },
  {
    name: 'Gökdepe',
    province: 'Ahal'
  },
  {
    name: 'Gumdag',
    province: 'Balkan'
  },
  {
    name: 'Hazar',
    province: 'Balkan'
  },
  {
    name: 'Köneürgenç',
    province: 'Daşoguz'
  },
  {
    name: 'Magdanly',
    province: 'Lebap'
  },
  {
    name: 'Mary',
    province: 'Mary'
  },
  {
    name: 'Serdar',
    province: 'Balkan'
  },
  {
    name: 'Serhetabat',
    province: 'Mary'
  },
  {
    name: 'Seýdi',
    province: 'Lebap'
  },
  {
    name: 'Şatlyk',
    province: 'Mary'
  },
  {
    name: 'Tejen',
    province: 'Ahal'
  },
  {
    name: 'Türkmenabat',
    province: 'Lebap'
  },
  {
    name: 'Türkmenbaşy',
    province: 'Balkan'
  },
  {
    name: 'Ýolöten',
    province: 'Mary'
  }
]

export default cities



// WEBPACK FOOTER //
// ./src/libraries/cities.js